import React, { Fragment } from 'react';
import Text from '../../atoms/text/Text';
import styles from './Table.module.scss';
import Separator from '../../atoms/separator/Separator';
import { useTranslation } from 'react-i18next';
import useIsRtl from '../../../app/helpers/isRtl';

const semesterMapping2 = [
  { index: 'Semester_1', title: 'Semester 1', titleAR: 'الفصل الاول' },
  { index: 'Semester_2', title: 'Semester 2', titleAR: 'الفصل الاول' },
  { index: 'Semester_3', title: 'Semester 3', titleAR: 'الفصل الاول' },
  { index: 'Semester_4', title: 'Semester 4', titleAR: 'الفصل الاول' },
];

const MajorTable = ({ data, year, hasTitles, removeColumn }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = useIsRtl();

  const sortedSemesterKeys = Object.keys(data).sort((a, b) => {
    const getSemesterNumber = (semesterStr) => {
      const match = semesterStr.match(/Semester_(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    };

    return getSemesterNumber(a) - getSemesterNumber(b);
  });

  const totalCredits = Object.keys(data).reduce((total, semesterKey) => {
    const semesterCourses = data[semesterKey]?.courses || [];
    const semesterCredits = semesterCourses.reduce(
      (semesterTotal, course) => semesterTotal + (course.courseCredits || 0),
      0
    );
    return total + semesterCredits;
  }, 0);

  return (
    <div className={styles['table-container']}>
      <div className={styles['header']}>
        <Text
          title={year}
          variant="text-bold-20"
          style={{ textTransform: 'uppercase' }}
        />
        <Text
          title={totalCredits}
          variant="text-bold-20"
          style={{ textTransform: 'uppercase' }}
        />
      </div>
      <table className={styles['table']}>
        {hasTitles && (
          <thead>
            <tr>
              {!removeColumn && (
                <th
                  className={`${styles.responsiveTH} ${isRtl ? styles.alignRight : ''}`}
                  style={{ width: '100px' }}
                >
                  <Text
                    title="Major.Semesters"
                    variant="text-bold-20-green"
                    style={{ textTransform: 'uppercase' }}
                  />
                </th>
              )}
              <th
                className={`${styles.responsiveTH} ${isRtl ? styles.alignRight : ''}`}
              >
                <Text
                  title="Major.module_title"
                  variant="text-bold-20-green"
                  style={{ textTransform: 'uppercase' }}
                />
              </th>
              <th
                className={`${styles.responsiveTH} ${isRtl ? styles.alignRight : ''}`}
                style={{ width: isRtl ? '260px' : '312px' }}
              >
                <Text
                  title="Major.module_credits"
                  variant="text-bold-20-green"
                  style={{ textTransform: 'uppercase' }}
                />
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {sortedSemesterKeys.map((semesterKey, semesterIndex) => (
            <Fragment key={semesterKey}>
              {data[semesterKey]?.courses?.map((major, majorIndex) => (
                <Fragment key={`${semesterIndex}-${majorIndex}`}>
                  <tr>
                    {majorIndex === 0 && !removeColumn && (
                      <td className={styles.responsiveTR}>
                        <Text
                          title={
                            semesterMapping2.find(
                              (item) => item.index === semesterKey
                            ).titleAR
                          }
                          variant="text-regular-18-black"
                          className={styles['semester-title']}
                        />
                      </td>
                    )}
                    {!majorIndex === 0 && !removeColumn && <td></td>}
                    <td className={styles.responsiveTR}>
                      <Text
                        title={major.courseAR}
                        variant="text-regular-18-black"
                      />
                    </td>
                    <td
                      className={styles.responsiveTR}
                      style={{ textAlign: isRtl ? 'center' : 'center' }}
                    >
                      <Text
                        title={major.courseCredits}
                        variant="text-regular-18-black"
                      />
                    </td>
                  </tr>
                  {!(
                    semesterIndex === sortedSemesterKeys.length - 1 &&
                    majorIndex === data[semesterKey]?.courses?.length - 1
                  ) && (
                    <tr>
                      <td colSpan={!removeColumn ? 3 : 2}>
                        <Separator
                          direction="horizontal"
                          style={{ height: '2rem' }}
                        />
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}
              {Object.keys(data).length - 1 !== semesterIndex && (
                <tr>
                  <td colSpan={!removeColumn ? 3 : 2}>
                    <Separator
                      direction="horizontal"
                      style={{ height: '50px' }}
                    />
                  </td>
                </tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const FeesTable = ({ data, fees, knowledge, total }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isRtl = currentLanguage !== 'en';
  return (
    <div className={styles['fees-table']}>
      <div
        className={styles['table-header']}
        style={{ backgroundColor: 'black' }}
      >
        <div
          className={`${styles['header-cell']} ${styles.hideOnPhone} ${
            isRtl ? 'rtl' : ''
          }`}
        >
          <Text
            title="Major.Title"
            variant="text-bold-20"
            className={styles.title}
          />
        </div>
        <div
          className={`${styles['header-cell']} ${styles.hideOnPhone} ${
            isRtl ? 'rtl' : ''
          }`}
        >
          <Text
            title="Major.Approved_Fees"
            variant="text-bold-20"
            className={styles.title}
          />
        </div>
        <div
          className={`${styles['header-cell']} ${styles.hideOnPhone} ${
            isRtl ? 'rtl' : ''
          }`}
        >
          <Text
            title="Major.Knowledge_and_Innovation_Dirham_Fees"
            variant="text-bold-20"
          />
        </div>
        <div
          className={`${styles['header-cell']} ${styles.showOnPhone} ${
            isRtl ? 'rtl' : ''
          }`}
        >
          <Text
            title="Major.PROGRAM_ANNUAL_FEES"
            variant="text-bold-20"
            style={{ textTransform: 'uppercase' }}
          />
        </div>
        <div
          className={`${styles['header-cell']} ${styles.hideOnPhone} ${
            isRtl ? 'rtl' : ''
          }`}
        >
          <Text
            title="Major.Program_Sum_Fees"
            variant="text-bold-20"
            style={{ textTransform: 'uppercase' }}
          />
        </div>
      </div>

      {data?.map((item, index) => (
        <div className={styles['table-row-wrapper']}>
          <div key={index} className={`${styles['table-row']}`}>
            <div
              className={`${styles['row-cell']} ${styles.hideOnPhone} ${
                isRtl ? 'rtl' : ''
              }`}
            >
              <Text
                title={item.title}
                variant="text-regular-18-black"
                className={styles.title}
              />
            </div>
            <div
              className={`${styles['row-cell']} ${styles.hideOnPhone} ${
                isRtl ? 'rtl' : ''
              }`}
            >
              <Text
                title={fees ?? item.approvedFees}
                variant="text-regular-18-black"
              />
            </div>
            <div
              className={`${styles['row-cell']} ${styles.hideOnPhone} ${
                isRtl ? 'rtl' : ''
              }`}
            >
              <Text
                title={knowledge ?? item.extraFees}
                variant="text-regular-18-black"
              />
            </div>
            <div
              className={`${styles['row-cell']} ${styles.hideOnPhone} ${
                isRtl ? 'rtl' : ''
              }`}
            >
              {/* parseInt(item.extraFees) +  */}
              <Text
                title={(total ?? item.total)?.toLocaleString?.() ?? ''}
                variant="text-regular-18-black"
              />
              <Text
                title={total == undefined ? item.totalFees : ''}
                variant="text-regular-18-black"
              />
            </div>
            <div
              className={`${styles['row-cell-container']} ${
                styles.showOnPhone
              } ${isRtl ? 'rtl' : ''}`}
            >
              <div
                className={`${styles['row-cell']} ${styles.showOnPhone} ${
                  isRtl ? 'rtl' : ''
                }`}
              >
                <Text title={item.title} variant="text-bold-20-black" />
              </div>
              <div
                className={`${styles['row-cell']} ${styles.showOnPhone} ${
                  isRtl ? 'rtl' : ''
                }`}
              >
                <Text
                  title={fees ?? item.approvedFees}
                  variant="text-regular-20-black"
                />
              </div>{' '}
              <div
                className={`${styles['row-cell']} ${styles.showOnPhone} ${
                  isRtl ? 'rtl' : ''
                }`}
              >
                <Text
                  title="Major.Knowledge_and_Innovation_Dirham_Fees"
                  variant="text-bold-20-black"
                />
              </div>
              <div
                className={`${styles['row-cell']} ${styles.showOnPhone} ${
                  isRtl ? 'rtl' : ''
                }`}
              >
                <Text
                  title={knowledge ?? item.extraFees}
                  variant="text-regular-20-black"
                />
              </div>
            </div>
          </div>
          <div className={styles.separatorWrapper}>
            {index < data.length - 1 ? (
              <Separator direction="horizontal" style={{ height: '2rem' }} />
            ) : (
              <div className={styles.endLine}></div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
const ProgramsTable = ({ data, title }) => {
  const isRtl = useIsRtl();

  return (
    <div className={styles['program-table']}>
      <div
        className={styles['table-header']}
        style={{ backgroundColor: 'black' }}
      >
        <div className={`${styles['header-cell']}  ${isRtl ? 'rtl' : ''}`}>
          <Text title={title} variant="text-bold-20" />
        </div>
      </div>

      {data?.map((item, index) => (
        <div className={styles['table-row-wrapper']}>
          <div
            key={index}
            className={`${styles['table-row']}`}
            style={{ marginTop: index === 0 ? '3rem' : '' }}
          >
            <div className={`${styles['row-cell']}  ${isRtl ? 'rtl' : ''} `}>
              <Text
                title={item.title}
                variant="text-bold-20-green"
                className={styles.programTitle}
              />
            </div>

            <div className={`${styles['row-cell']}  ${isRtl ? 'rtl' : ''} `}>
              {Array.isArray(item.approvedFees) ? (
                <ul>
                  {item.approvedFees.map((titleItem, index) => (
                    <li key={index}>
                      <Text title={titleItem} variant="text-regular-20-black" />
                    </li>
                  ))}
                </ul>
              ) : (
                <Text
                  title={item.approvedFees}
                  variant="text-regular-20-black"
                />
              )}
            </div>
          </div>
          <div className={styles.separatorWrapper}>
            {index < data.length - 1 ? (
              <Separator direction="horizontal" style={{ height: '3rem' }} />
            ) : (
              <div className={styles.endLine}></div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export default FeesTable;
export { MajorTable, FeesTable, ProgramsTable };
